/** Three attempts at most; online can shorten the wait, never replenish the budget. */
export class GuideHttpFehler extends Error {
  constructor(public status: number) { super(`HTTP ${status}`); }
}
export function guideNetzFehler(e: unknown): string {
  if (e instanceof GuideHttpFehler) return `Server antwortet mit HTTP ${e.status}`;
  if ((e instanceof Error || e instanceof DOMException) && e.name === 'TimeoutError') return 'Antwort dauert zu lange';
  if (e instanceof TypeError) return 'Verbindung zum Server unterbrochen';
  return e instanceof Error ? e.message : 'Anfrage fehlgeschlagen';
}
function wiederholbar(e: unknown): boolean {
  return e instanceof GuideHttpFehler ? e.status >= 500 || e.status === 408 || e.status === 429
    : e instanceof TypeError || ((e instanceof Error || e instanceof DOMException) && e.name === 'TimeoutError');
}
export function warteAufNetz(signal: AbortSignal, ms: number): Promise<void> {
  return new Promise(resolve => {
    const fertig = () => { clearTimeout(timer); window.removeEventListener('online', fertig); signal.removeEventListener('abort', fertig); resolve(); };
    const timer = setTimeout(fertig, ms);
    window.addEventListener('online', fertig, { once: true }); signal.addEventListener('abort', fertig, { once: true });
    if (signal.aborted) fertig();
  });
}
export async function mitNetzWiederholung<T>(anfrage: () => Promise<T>, signal: AbortSignal, fehler: (e: unknown) => void): Promise<T | undefined> {
  for (let n = 0; n < 3 && !signal.aborted; n++) {
    try { const wert = await anfrage(); return signal.aborted ? undefined : wert; }
    catch (e) {
      if (signal.aborted) return undefined;
      fehler(e);
      if (n === 2 || !wiederholbar(e)) return undefined;
      await warteAufNetz(signal, n === 0 ? 1000 : 3000);
    }
  }
  return undefined;
}
